import Vue from "vue";
import VueRouter from "vue-router";
import RakutenHome from "../pages/RakutenHome";
import LoginPage from "../pages/LoginPage.vue";
import WatchStream from "../pages/WatchStream.vue";

import store from "@/store";

Vue.use(VueRouter);

const routes = [
   {
      path: "/",
      name: "LandingPage",
      component: RakutenHome
   },
   {
      path: "/chronicle",
      name: "RakutenChronicle",
      component: () => import(/* webpackChunkName: "login" */ "../pages/RakutenChronicle.vue")
   },
   {
      path: "/works",
      name: "RakutenWorks",
      component: () => import(/* webpackChunkName: "login" */ "../pages/RakutenWorks.vue")
   },
   {
      path: "/login",
      name: "LoginPage",
      component: LoginPage
   },
   {
      path: "/event/:id?",
      name: "EventPage",
      component: () => import(/* webpackChunkName: "event" */ "../pages/EventPage.vue")
   },
   {
      path: "/stream/:slug?",
      name: "WatchStream",
      component: WatchStream,
      // meta: { requiresAuth: true }
   },
   {
      path: "*",
      name: "NotFound",
      component: () => import(/* webpackChunkName: "404" */ "../pages/404.vue")
   }
];

const router = new VueRouter({
   mode: "history",
   base: process.env.BASE_URL,
   routes
});

router.beforeEach(authGuard);

const cookies = Vue.prototype.$cookies;
function authGuard(to, from, next) {
   window.scrollTo({ top: 0, behavior: "smooth" });
   const isAuth = cookies.get("access_token") || store.getters.isLoggedIn;
   if (to.matched.some((record) => record.meta.requiresAuth) && !isAuth) {
      window.location.href = "/";
      //  next({ name: "LandingPage" });
   } else {
      next();
   }
}

export default router;
